import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'select2/select2.css'
import 'toastr/toastr.scss'
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-simple-tree-menu/dist/main.css';
import './lib/Interpolate';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './services/Signalr';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();